export default __webpack_public_path__ + "static/media/Sri Swamy Jewellers Logo.png.cd6c70b8.png";